module.exports = __webpack_public_path__ + "img/2-8588.4459f4c4.png";